import script from "./Inicio.vue?vue&type=script&setup=true&lang=js"
export * from "./Inicio.vue?vue&type=script&setup=true&lang=js"

import "./Inicio.vue?vue&type=style&index=0&id=562ff292&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-562ff292"]])

export default __exports__